var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",class:{
    'c-input': true,
    'form-control': true,
    'is-valid': _vm.state !== 'invalid',
    'is-invalid': _vm.state === 'invalid'
  },attrs:{"id":_vm.id,"aria-invalid":_vm.state === 'invalid',"aria-required":_vm.required ? true : null,"autocomplete":_vm.autocomplete,"disabled":_vm.disabled,"name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"required":_vm.required,"type":_vm.type},domProps:{"value":_vm.value},on:{"input":_vm.onInput,"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }